export default (state = [], action) => {
  switch (action.type) {
    case 'POST_SALES_ORDER_ITEMS':
      return [ ...state, ...action.payload ] || false
    default:
      return state
  }
}